module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6a01561dd5ab6bb86d5e1b1a5d0a2407.png";